import React, { useState } from 'react';
import { Phone, Mail, MapPin, Send, ArrowRight } from 'lucide-react';

const contactInfo = {
  phone: "+34 673 361 681",
  email: "javierblanco@jbrinmobiliaria.com",
  address: "Calle Goya 6",
  city: "Valladolid"
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    service: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
    submissions.push({ ...formData, date: new Date().toISOString() });
    localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '', service: '' });
    }, 3000);
  };

  return (
    <section id="contacto" className="bg-[#fffef2] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <span className="text-sm text-[#1a365d] tracking-wider uppercase">Contacto</span>
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mt-4 leading-tight">
              Hablemos sobre tu proyecto inmobiliario
            </h2>
            <p className="text-base text-[#666666] mt-4 leading-relaxed max-w-lg">
              Estoy aquí para ayudarte a tomar las mejores decisiones. Solicita una consulta gratuita y sin compromiso. Con más de 5.000 transacciones realizadas, tu propiedad está en las mejores manos.
            </p>

            <div className="mt-10 space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#f6f5e8]">
                  <Phone className="w-5 h-5 text-[#1a365d]" />
                </div>
                <div>
                  <p className="text-sm text-[#666666] mb-1">Teléfono</p>
                  <a href={"tel:" + contactInfo.phone} className="text-lg text-[#333333] hover:text-[#1a365d] transition-colors">
                    {contactInfo.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#f6f5e8]">
                  <Mail className="w-5 h-5 text-[#1a365d]" />
                </div>
                <div>
                  <p className="text-sm text-[#666666] mb-1">Email</p>
                  <a href={"mailto:" + contactInfo.email} className="text-lg text-[#333333] hover:text-[#1a365d] transition-colors">
                    {contactInfo.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#f6f5e8]">
                  <MapPin className="w-5 h-5 text-[#1a365d]" />
                </div>
                <div>
                  <p className="text-sm text-[#666666] mb-1">Oficina</p>
                  <p className="text-lg text-[#333333]">{contactInfo.address}</p>
                  <p className="text-base text-[#666666]">{contactInfo.city}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#f6f5e8] p-8 lg:p-10">
            {isSubmitted ? (
              <div className="h-full flex flex-col items-center justify-center text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center bg-[#1a365d] rounded-full mb-6">
                  <Send className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-medium text-[#333333] mb-2">Mensaje enviado</h3>
                <p className="text-sm text-[#666666]">Me pondré en contacto contigo lo antes posible.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm text-[#333333] mb-2">Nombre completo</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-[#fffef2] border border-[#ebeade] text-[#333333] text-sm focus:outline-none focus:border-[#1a365d] transition-colors"
                    placeholder="Tu nombre"
                  />
                </div>

                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="email" className="block text-sm text-[#333333] mb-2">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-[#fffef2] border border-[#ebeade] text-[#333333] text-sm focus:outline-none focus:border-[#1a365d] transition-colors"
                      placeholder="tu@email.com"
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm text-[#333333] mb-2">Teléfono</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-[#fffef2] border border-[#ebeade] text-[#333333] text-sm focus:outline-none focus:border-[#1a365d] transition-colors"
                      placeholder="+34 600 000 000"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="service" className="block text-sm text-[#333333] mb-2">Servicio de interés</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-[#fffef2] border border-[#ebeade] text-[#333333] text-sm focus:outline-none focus:border-[#1a365d] transition-colors"
                  >
                    <option value="">Selecciona una opción</option>
                    <option value="venta">Venta de propiedad</option>
                    <option value="compra">Compra de inmueble</option>
                    <option value="alquiler">Gestión de alquiler</option>
                    <option value="valoracion">Valoración gratuita</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm text-[#333333] mb-2">Mensaje</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    required
                    className="w-full px-4 py-3 bg-[#fffef2] border border-[#ebeade] text-[#333333] text-sm focus:outline-none focus:border-[#1a365d] transition-colors resize-none"
                    placeholder="Cuéntame sobre tu proyecto..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full flex items-center justify-center gap-2 px-8 py-4 bg-[#1a365d] text-white text-sm font-medium hover:bg-[#2d4a7c] transition-colors group"
                >
                  Enviar mensaje
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
